module.exports = __webpack_public_path__ + "img/ezra-cornell.4aa66cc9.png";